// Problem: Whe can not tell if live updated was caused by current application and there might be cases
// when domain event is propagated to duplexer faster then response about comment creation. In this situation
// user would get live update message about his own just created comment. So we filter
// all live updates with the current users identity.
export function filterOwnComments({ emitTo: emit, getCurrentOwner, }) {
    return (message) => {
        const { createdBy: author } = message;
        const isCreatedByMe = (() => {
            const currentOwner = getCurrentOwner();
            if (currentOwner.type === 'MEMBER' &&
                author?.identityType === 'MEMBER' &&
                currentOwner.member.id === author.identityId) {
                return true;
            }
            if (currentOwner.type === 'ANONYMOUS' &&
                (author?.identityType === 'ANONYMOUS' || !author?.identityType) &&
                author?.identityId === currentOwner.identityId) {
                return true;
            }
            return false;
        })();
        if (!isCreatedByMe) {
            emit([message]);
        }
    };
}
//# sourceMappingURL=wait-for-idle-create-requests.js.map